var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarLogo = function SvgCalendarLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendarLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.235 4.763H4.762v14.474h14.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "m13.106 9.974.663.947 1.042-.758v5.495h1.137v-7.2H15zM11.304 11.832c.412-.377.667-.901.667-1.48 0-1.149-1.009-2.084-2.248-2.084-1.054 0-1.955.664-2.191 1.614l1.09.277c.109-.437.571-.754 1.1-.754.62 0 1.125.425 1.125.948s-.504.947-1.124.947h-.656v1.137h.656c.711 0 1.311.494 1.311 1.079 0 .595-.57 1.079-1.27 1.079-.633 0-1.174-.402-1.26-.933l-1.11.181c.173 1.077 1.191 1.889 2.369 1.889 1.32 0 2.395-.994 2.395-2.216 0-.673-.332-1.277-.854-1.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBC02D",
    d: "M18.578 23.842H5.42l-.658-2.631.658-2.632h13.158l.657 2.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "m21.21 19.237 2.631-.658V5.421l-2.631-.658-2.632.658V18.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "m18.58 5.421.657-2.631L18.58.158H2.132c-1.09 0-1.974.884-1.974 1.974v16.447l2.632.658 2.631-.658V5.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53935",
    d: "M18.578 18.579v5.263l5.263-5.263z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M21.868.158h-3.29v5.263h5.263v-3.29c0-1.09-.883-1.973-1.973-1.973M2.132 23.842h3.29V18.58H.157v3.29c0 1.09.884 1.973 1.974 1.973"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendarLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCalendarLogo;